import { Flex, Dialog, CircularProgress, Text } from '@shared/components';

export default function GenerateQSetLoadingModal() {
  return (
    <Dialog open={true} sx={{ '& .MuiPaper-root': { width: 'unset' } }}>
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          gap: (theme) => theme.spacing(4),
          p: (theme) => theme.spacing(6),
        }}
      >
        <CircularProgress />
        <Text variant='h5' sx={{ fontWeight: 600 }}>
          Generating QSet
        </Text>
        <Text>Please wait while we generate your QSet</Text>
      </Flex>
    </Dialog>
  );
}
